import { render, staticRenderFns } from "./SarjanaForm.vue?vue&type=template&id=57006af4&scoped=true"
import script from "./SarjanaForm.vue?vue&type=script&lang=js"
export * from "./SarjanaForm.vue?vue&type=script&lang=js"
import style0 from "./SarjanaForm.vue?vue&type=style&index=0&id=57006af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57006af4",
  null
  
)

export default component.exports